// Ameen Spices — shared UI behaviours for collection & product pages
(function(){
  const HOVER = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Stop the browser yanking scroll position around after a native form POST
  try{ if('scrollRestoration' in history) history.scrollRestoration='manual'; }catch(e){}

  // Smooth scroll
  let lenis;
  if(window.Lenis && !REDUCED){
    lenis=new Lenis({lerp:0.09,smoothWheel:true});
    window.lenis=lenis;
    (function raf(t){lenis.raf(t);requestAnimationFrame(raf);})();
    document.querySelectorAll('a[href^="#"]').forEach(a=>{
      a.addEventListener('click',e=>{const id=a.getAttribute('href');if(id.length>1){const el=document.querySelector(id);if(el){e.preventDefault();lenis.scrollTo(el,{offset:-80});}}});
    });
  }

  // Nav scroll state
  const topbar=document.getElementById('topbar');
  function navState(y){ if(topbar) topbar.classList.toggle('scrolled', y>60); }
  if(lenis){ lenis.on('scroll',({scroll})=>navState(scroll)); } else { window.addEventListener('scroll',()=>navState(window.scrollY)); }
  navState(window.scrollY);

  // Mobile menu
  const burger=document.querySelector('.nav__burger'), mm=document.getElementById('mobileMenu');
  if(burger&&mm){
    function setMenu(o){mm.classList.toggle('open',o);burger.classList.toggle('active',o);document.body.classList.toggle('menu-open',o);if(window.lenis){o?lenis.stop():lenis.start();}}
    burger.addEventListener('click',()=>setMenu(!mm.classList.contains('open')));
    mm.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setMenu(false)));
  }

  // Reveal on scroll (IntersectionObserver)
  const io=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(!e.isIntersecting) return;
      const el=e.target;
      if(el.hasAttribute('data-reveal-stagger')){
        [...el.children].forEach((c,i)=>{const d=Math.min(i*0.07,0.6);c.style.transition=`opacity .9s var(--ease) ${d}s, transform .9s var(--ease) ${d}s`;c.style.opacity=1;c.style.transform='none';});
      } else {
        el.style.transition='opacity 1s var(--ease), transform 1s var(--ease)';el.style.opacity=1;el.style.transform='none';
      }
      io.unobserve(el);
    });
  },{threshold:0.12});
  document.querySelectorAll('[data-reveal],[data-reveal-stagger]').forEach(el=>io.observe(el));

  // Carousels
  document.querySelectorAll('[data-nav]').forEach(navEl=>{
    const key=navEl.getAttribute('data-nav'),track=document.getElementById('track-'+key);
    if(!track)return;
    const [prev,next]=navEl.querySelectorAll('button');
    const step=()=>Math.min(track.clientWidth*0.8,580);
    function update(){prev.disabled=track.scrollLeft<5;next.disabled=track.scrollLeft>track.scrollWidth-track.clientWidth-5;}
    prev.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
    next.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
    track.addEventListener('scroll',update,{passive:true});setTimeout(update,300);
  });
  if(HOVER){
    document.querySelectorAll('.carousel__track').forEach(track=>{
      let down=false,sx,ss,moved=false;
      track.addEventListener('pointerdown',e=>{down=true;moved=false;sx=e.pageX;ss=track.scrollLeft;track.classList.add('dragging');});
      window.addEventListener('pointerup',()=>{down=false;track.classList.remove('dragging');});
      track.addEventListener('pointermove',e=>{if(!down)return;const dx=e.pageX-sx;if(Math.abs(dx)>5)moved=true;track.scrollLeft=ss-dx;});
      track.addEventListener('click',e=>{if(moved)e.preventDefault();},true);
    });
  }
  window.HOVER = HOVER;

  // Success popup — shown after native form posts redirect back with a flag
  function showThanksPopup(title, message, cta){
    var ov=document.createElement('div'); ov.className='thanks-pop';
    ov.innerHTML='<div class="thanks-pop__card" role="dialog" aria-live="polite"><div class="thanks-pop__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg></div><h3>'+title+'</h3><p>'+message+'</p><button class="btn btn--gold" type="button">'+(cta||'Continue')+'</button></div>';
    document.body.appendChild(ov);
    document.body.classList.add('menu-open'); if(window.lenis) lenis.stop();
    void ov.offsetWidth; // commit initial state so the fade-in transition runs
    ov.classList.add('show');
    function close(){ ov.classList.remove('show'); document.body.classList.remove('menu-open'); if(window.lenis) lenis.start(); setTimeout(function(){ if(ov.parentNode) ov.parentNode.removeChild(ov); },420); }
    ov.addEventListener('click',function(e){ if(e.target===ov || e.target.closest('button')) close(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
    setTimeout(close, 8000);
  }
  (function(){
    var p=new URLSearchParams(location.search);
    if(p.get('customer_posted')==='true'){
      window.scrollTo(0,0); if(window.lenis) lenis.scrollTo(0,{immediate:true});
      showThanksPopup('You&rsquo;re on the list','Thank you for subscribing. Watch your inbox for new blends, recipes and members-only offers.','Continue shopping');
      try{ history.replaceState(null,'',location.pathname); }catch(e){}
    } else if(p.get('review_submitted')==='1'){
      showThanksPopup('Thank you for your review','Your review has been submitted and will appear on the product page once it&rsquo;s passed our automated check for spam and bot activity.','Continue shopping');
      try{ history.replaceState(null,'',location.pathname); }catch(e){}
    }
  })();
})();
